import React, { useContext, useState } from 'react'
import { Tooltip } from 'react-tooltip'
import CustomerFilter from './CustomerFilter'
import Button from '../../../components/Button'
import GlobalContext from '../../../components/Context/GlobalContext'
import { checkPrivilege } from '../../../CommonMethods/checkPrivilege'

function Topbar({
    Title,
    tooltip,
    DateRange,
    DateRangeError,
    SetDateRangeError,
    handleApplyFilter,
    handleDatePickerValidation,
    handleSetDate,
    DateErrorClear,
    SearchValue,
    setSearchValue,
    handleOnClickSearch,
    List,
    handleClick,
    exportLoading,
    sendSms,
    setSendSms,
    customers,
    setCustomers,
    smsList,
    setSmsList,
    setSmsModal,
    sendEmail,
    setSendEmail,
    emailList,
    setEmailList,
    setEmailModal
}) {
    const { setToastmessage, setToastErrorMessage, setToastError } = useContext(GlobalContext)
    const [searchVisible, setSearchVisible] = useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [timer, setTimer] = useState(null)

    const handleSearch = (newValue) => {
        setSearchValue(newValue);
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            handleOnClickSearch("search", newValue)
        }, 500)
        setTimer(newTimer)
    }

    const handleSendEmail = () => {
        setSendEmail(true);
        setEmailList([]); // Reset email list
        setCustomers(''); // Reset customer selection
    }

    const hasSendSms = checkPrivilege('send_SMS')
    return (
        <div className='flex justify-between'>
            <div>
                <h1 className="font-playfair text-xl text-[#4B4B4B] font-[500] pl-1">{Title}</h1>
            </div>
            <div className='flex items-center gap-6'>
                <div className="relative mr-[20px] h-[42px]">
                    <input
                        type="text"
                        // value={searchParams.search}
                        value={SearchValue}
                        data-testid="search"
                        onChange={(e) => handleSearch(e.target.value)}
                        placeholder="Customer Name, Email Address, Country Code"
                        className={`w-[350px] rounded-[8px] pr-10 pl-[14px] py-2 z-1 border border-[#8E8E8E] 
                            placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] 
                            outline-none ${searchVisible ? 'block' : 'hidden'}`}
                    />
                    <img
                        src="/assets/images/search.svg"
                        alt=""
                        onClick={() => setSearchVisible(!searchVisible)}
                        data-testid='search-btn'
                        // className="absolute top-[11px] right-[19px]"
                        className={`${searchVisible ? 'absolute top-[12px]  right-4' : 'mr-4 mt-[12px]'}   `}
                    // className='absolute top-[12px]  right-4'
                    />
                </div>
                {!sendSms && hasSendSms && <div className="relative " data-tooltip-id="my-tooltip-1">
                    <img
                        src="/assets/images/Ghost.svg"
                        className="cursor-pointer hover:bg-[#FBEBF4] p-3 rounded-full"
                        alt="add"
                        data-testid='sms-btn'
                        onClick={() => setSendSms(true)}
                    />
                    <Tooltip
                        id="my-tooltip-1"
                        place="bottom"
                        content={tooltip}
                    />
                </div>
                }

                <CustomerFilter
                    isFilterOpen={isFilterOpen}
                    setIsFilterOpen={setIsFilterOpen}
                    DateRange={DateRange}
                    DateRangeError={DateRangeError}
                    SetDateRangeError={SetDateRangeError}
                    handleDatePickerValidation={handleDatePickerValidation}
                    handleApplyFilter={handleApplyFilter}
                    handleSetDate={handleSetDate}
                    DateErrorClear={DateErrorClear}
                />

                {!sendSms && List?.data?.length > 0 && <Button
                    classKey={`px-4 py-[5px] border border-[#9E2064] w-[88px] text-primary rounded-[12px]`}
                    text="Export"
                    disabled={exportLoading}
                    loading={exportLoading}
                    type="button"
                    handleClick={handleClick}
                    color="pink"
                    testId={'export-btn'}
                />}
                {sendSms &&
                    <div className='flex gap-3'>
                        <Button
                            classKey={`px-4 py-[5px] border border-[#9E2064] w-[88px] text-primary rounded-[12px]`}
                            text="Cancel"
                            // disabled={exportLoading}
                            // loading={exportLoading}
                            type="button"
                            handleClick={() => {
                                setCustomers('');
                                setSendSms(false);  
                                setSmsList([]);
                            }}
                            color=""
                            testId={'cancel-btn'}
                        />
                        <Button
                            classKey={`px-4 py-[5px] border bg-[#9E2064]  text-white rounded-[12px]`}
                            text="Send Email"
                            // disabled={exportLoading}
                            // loading={exportLoading}
                            type="button"
                            handleClick={()=>{
                                if(customers !== 'select_all'){
                                    if(smsList.length > 0){
                                        setSmsModal(true);
                                        return;
                                    }else{
                                        setToastError("Please choose at least one customer");
                                        return;
                                    }
                                }
                                setSmsModal(true);
                            }
                            }
                            color=""
                            testId={'send-btn'}
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default Topbar
